import * as React from 'react';
import Facebook from '../../../assets/social/Facebook.esm.js';
import Instagram from '../../../assets/social/Instagram.esm.js';
import Linkedin from '../../../assets/social/Linkedin.esm.js';
import Medium from '../../../assets/social/Medium.esm.js';
import X from '../../../assets/social/X.esm.js';
import classNames from 'classnames';
import styles from './SocialMediaLinks.module.esm.js';

var SocialMediaLinks = function (_a) {
    var _b = _a.isDesktop, isDesktop = _b === void 0 ? false : _b, followUsText = _a.followUsText;
    return (React.createElement("ul", { className: classNames(styles.gridChild, styles.root, isDesktop ? styles.desktop : styles.mobile) },
        React.createElement("li", null,
            React.createElement("a", { "data-cy": "footer_linkedin-link", href: "http://www.linkedin.com/company/invitae", rel: "noopener noreferrer", target: "_blank", title: "".concat(followUsText, " Linkedin") },
                React.createElement(Linkedin, { idSuffix: isDesktop ? 'desktop' : 'mobile' }))),
        React.createElement("li", null,
            React.createElement("a", { "data-cy": "footer_instagram-link", href: "https://www.instagram.com/invitae", rel: "noopener noreferrer", target: "_blank", title: "".concat(followUsText, " Instagram") },
                React.createElement(Instagram, { idSuffix: isDesktop ? 'desktop' : 'mobile' }))),
        React.createElement("li", null,
            React.createElement("a", { "data-cy": "footer_facebook-link", href: "https://www.facebook.com/InVitae", rel: "noopener noreferrer", target: "_blank", title: "".concat(followUsText, " Facebook") },
                React.createElement(Facebook, { idSuffix: isDesktop ? 'desktop' : 'mobile' }))),
        React.createElement("li", null,
            React.createElement("a", { "data-cy": "footer_x-link", href: "https://x.com/Invitae", rel: "noopener noreferrer", target: "_blank", title: "".concat(followUsText, " X (formerly Twitter)") },
                React.createElement(X, { idSuffix: isDesktop ? 'desktop' : 'mobile' }))),
        React.createElement("li", null,
            React.createElement("a", { "data-cy": "footer_medium-link", href: "https://blog.invitae.com", rel: "noopener noreferrer", target: "_blank", title: "".concat(followUsText, " Medium") },
                React.createElement(Medium, { idSuffix: isDesktop ? 'desktop' : 'mobile' })))));
};

export { SocialMediaLinks as default };
//# sourceMappingURL=SocialMediaLinks.esm.js.map
